exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-no-padding-btn[data-v-42554bba]{padding:8px 0!important;color:#000!important}.btn-width[data-v-42554bba]{min-height:auto;width:150px}", ""]);

// exports
